const routes = [


	//---- Logged in "Home" page (start/landing/dashboard)
	{
		path: '/home', 
		name: "home", 
		component: () => import("/home/index.vue"),
		meta: { layout: "primary", layoutType: "default", layoutContainer: "none", isPublic: false, module: "", parentRouteName: "", pageTitle: "Home", kbFile: "home", kbTitle: "" } 
	},
	{ 
		path: '/home/LotusOnly', 
		name: "home-lotus-only-view", 
		component: () => import("/home/index.vue"),
		meta: { layout: "primary", layoutType: "default", layoutContainer: "none", isPublic: false, module: "", parentRouteName: "", pageTitle: "Home", kbFile: "home", kbTitle: "" } 
	},




	//---- Support
	{ 
		path: '/support', 
		name: "support",
		component: () => import("/support/index.vue"),
		meta: { layout: "primary", module: "", parentRouteName: "", pageTitle: "Request Support", kbFile: "support", kbTitle: "Support" } 
	},

	


	
	//---- "Background Tasks"
	{ 
		path: '/background-tasks',
		name: "background-tasks", 
		component: () => import("/shared/background-tasks.vue"),
		meta: { layout: "primary", module: "", parentRouteName: "", pageTitle: "Background Tasks" }
	},



]


export default routes;